<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="container">
                    <div class="modal-header">
                        <slot name="header">
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body"> 
                            <div class="imageContainer">
                                <img id="imageToCrop" src="/pop-banner.jpg" alt="">
                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <span class="closelink" @click="$emit('close')">NO, CLOSE THIS WINDOW</span>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </transition>
</template>



<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css'
import 'cropperjs/dist/cropper.min.js'

const axios = require('axios');
export default {
    name: 'imageCropper',
    props: {
        // printoutPdfFileName: null,
        // confirmationNum: null,
        // downloadFileName: null,
        // addToCartLink: String,
        // storeType: Number,
        // selectedAmulets: Array
    },
    data() {
        return {
        
        }
    },
    mounted () {
        console.log('cropper')
        const image = document.getElementById('imageToCrop');
        const cropper = new Cropper(image, {
            aspectRatio: 900 / 900,
            crop(event) {
                console.log(event.detail.x);
                console.log(event.detail.y);
                console.log(event.detail.width);
                console.log(event.detail.height);
                console.log(event.detail.rotate);
                console.log(event.detail.scaleX);
                console.log(event.detail.scaleY);
            }
        })
    },
    computed: {},
    methods:{
        downloadPrint() {

        }
    }
}
</script>

<style lang='scss'>
    /* @import 'node_modules/cropperjs/dist/cropper.min' */

    .modal-mask {
        position: absolute;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        /* width: 300px; */
        width:100%;
        box-sizing:border-box;
        height:100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        .imageContainer{
            display:block;
            position:relative;
            max-width:1107px;
        }
    }

    .modal-default-button {
    float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
    opacity: 0;
    }

    .modal-leave-active {
    opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    }
    img {
        max-width: 100%; /* This rule is very important, please do not ignore this! */
    }
</style>